import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { object, func, bool, string } from 'prop-types';
import { CloneObject } from '../../../utils/helpers';
import { TableCustom, MessageModal } from '../../common';
import { getDateToString } from '../../../utils/convert';
import { isNull } from '../../../utils/validator';
import DataTaggerModalRedux from '../DataTaggerModalRedux';
import { useEntidad } from '../../hooks/useEntidad';
import DebitoAutomaticoModal from '../DebitoAutomaticoModal';
import { ServerRequest } from '../../../utils/apiweb';
import { useLista } from '../../hooks';
import { APIS } from '../../../config/apis';
import {TIPS} from "../../../consts/tips";

const DebitosAutomaticosGrid = (props) => {

    //hooks
    const [state, setState] = useState({
        idCuenta: 0,
        disabled: false,
        showMessage: false,
        showForm: false,
        modeFormEdit: false,
        rowForm: null,
        dataTagger: {
            showModal: false,
            idEntidad: null
        }, 
        list: [],
        loading: false
    });
    const [mediosPagos, setMediosPago] = useState([]);

    const dispatch = useDispatch();
    const sequenceValue = useSelector( (state) => state.sequence.value );

    useEffect(() => {
        SearchMedioPago(state.idCuenta);
    }, [state.idCuenta]);

    const mount = () => {
        setState(prevState => {
            const list = props.data.list.filter(x => x.state !== 'r');
            return {...prevState,
                idCuenta: props.data.idCuenta,
                list: list
            };
        });
    }
    useEffect(mount, [props.data]);

    const [, getRowEntidad] = useEntidad({
        entidades: ['Tasa', 'SubTasa'],
        onLoaded: (entidades, isSuccess, error) => {
          if (isSuccess) {
            setState(prevState => ({...prevState}));
          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'Tasa_SubTasa',
          timeout: 0
        }
    });
    const [, getRowLista ] = useLista({
        listas: ['TipoMedioPago'],
        onLoaded: (listas, isSuccess, error) => {
          if (isSuccess) {

          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'TipoMedioPago',
          timeout: 0
        }
    });


    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
        const message = error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }

    function SearchMedioPago(idCuenta) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {
                setState(prevState => {
                    return {...prevState, loading: false };
                });
                setMediosPago(data);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
        };
  
        const paramsUrl = `/cuenta/${idCuenta}`;
        
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.MEDIO_PAGO,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );        
    }


    const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                    <div onClick={ (event) => handleClickDebitosAutomaticosAdd() } className="link">
                                       <span className="material-symbols-outlined" title="Nuevo">add</span>
                                    </div>
                                )}
                                </div>
    const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickDebitoAutomaicoView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickDebitosAutomaticosModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickDebitosAutomaticosRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickDebitosAutomaticosDataTagger(data.value) } className="link">
                                    <span className="material-symbols-outlined" title="Información adicional">info</span>
                                  </div>
                                  )} 
                              </div>

    const getDescTipoMedioPago = (id) => {
        const row = getRowLista('TipoMedioPago', id);
        return (row) ? row.nombre : '';
    }
    const getDescMedioPago = (id) => {
        const row = mediosPagos.find(f => f.id === id);
        return (row) ? `${getDescTipoMedioPago(row.idTipoMedioPago)} - ${row.numero} (${row.titular})` : '';
    }
    const getDescTasa = (id) => {
        const row = getRowEntidad('Tasa', id);
        return (row) ? `${row.codigo} - ${row.descripcion}` : '';
    } 
    const getDescSubTasa = (id) => {
        const row = getRowEntidad('SubTasa', id);
        return (row) ? `${row.codigo} - ${row.descripcion}` : '';
    }
    
    const tableColumns = [
        { Header: 'Medio de pago', Cell: (props) => getDescMedioPago(props.value), accessor: 'idMedioPago', width: '25%' },
        { Header: 'Tasa', Cell: (props) => getDescTasa(props.value), accessor: 'idTasa', width: '17%' },
        { Header: 'Sub tasa', Cell: (props) => getDescSubTasa(props.value), accessor: 'idSubTasa', width: '17%' },
        { Header: 'Desde', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaDesde', width: '10%' },
        { Header: 'Alta', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaAlta', width: '10%' },
        { Header: 'Débito anticipado', Cell: (props) => (props.value) ? 'Sí' : 'No', accessor: 'debitoAnticipado', width: '11%' },
        { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
    ];


    // handlers
    const handleClickDebitoAutomaicoView = (id) => {
        setState(prevState => {
          const rowForm = state.list.find(x => x.id === id);
          return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
        });
    }

    const handleClickDebitosAutomaticosAdd = () => {
        const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
        setState(prevState => {
            const rowForm = {
                id: idTemporal,
                idCuenta: state.idCuenta,
                idTasa: 0,
                idSubTasa: 0,
                idRubro: 0,
                idTipoSolicitudDebitoAutomatico: 0,
                numeroSolicitudDebitoAutomatico: '',
                idMedioPago: 0,
                detalleMedioPago: '',
                fechaDesde: null,
                fechaAlta: null,
                fechaBaja: null,
                debitoAnticipado: false,
                state: 'a'
            };
            return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
        });
        dispatch( sequenceActionNext() );
    }

    const handleClickDebitosAutomaticosModify = (id) => {
        setState(prevState => {
            const rowForm = state.list.find(x => x.id === id);
            return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
        });
    }

    const handleClickDebitosAutomaticosRemove = (id) => {
        setState(prevState => {
            const rowForm = state.list.find(x => x.id === id);
            return {...prevState, showMessage: true, rowForm: rowForm};
        });
    }

    const handleClickDebitosAutomaticosDataTagger = (id) => {
        setState(prevState => {
          return {...prevState, dataTagger: {showModal: true, idEntidad: id}};
        });
    }

    //funciones
    function RemoveDebitosAutomaticos(row) {
        row.state = 'r';
        props.onChange('DebitosAutomaticos', row);
    }

    function UpdateDebitosAutomaticos(row) {
        row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
        props.onChange('DebitosAutomaticos', row);
    }

    return (
    <>

        {state.dataTagger.showModal &&
            <DataTaggerModalRedux
                title="Información adicional de débitos automáticos"
                tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_DEBITOS_AUTOMATICOS_MODAL}
                processKey={props.processKey}
                entidad="DebitoAutomatico"
                idEntidad={state.dataTagger.idEntidad}
                disabled={props.disabled}
                onDismiss={() => {
                setState(prevState => {
                    return {...prevState, dataTagger: {showModal: false, idEntidad: null}};
                });
                }}
            />
        }

        {state.showMessage && 
            <MessageModal
                title={"Confirmación"}
                message={"¿Está seguro de borrar el registro?"}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showMessage: false, rowForm: null};
                    });
                }}
                onConfirm={() => {
                    const row = CloneObject(state.rowForm);
                    setState(prevState => {
                        return {...prevState, showMessage: false, rowForm: null};
                    });
                    RemoveDebitosAutomaticos(row);
                }}
            />
        }


        {state.showForm && 
            <DebitoAutomaticoModal
                processKey={props.processKey}
                disabled={!state.modeFormEdit}
                data={{
                    entity: state.rowForm
                }}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowForm: null};
                    });
                }}
                onConfirm={(row) => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowForm: null};
                    });
                    UpdateDebitosAutomaticos(row);
                  }}
            />
        }

        <TableCustom
            showFilterGlobal={false}
            className={'TableCustomBase'}
            columns={tableColumns}
            data={state.list}
        />

    </>
    );
}

DebitosAutomaticosGrid.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onChange: func.isRequired
  };
  
DebitosAutomaticosGrid.defaultProps = {
    disabled: false
};


export default DebitosAutomaticosGrid;